import { render } from "./ServerSetupRequirements.vue?vue&type=template&id=cd8519b2&lang=true"
import script from "./ServerSetupRequirements.vue?vue&type=script&lang=js"
export * from "./ServerSetupRequirements.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__